/* =============================================================
   Mingo Marker — animation initialization
   - Reveal-on-scroll using IntersectionObserver (no library needed)
   - Optional GSAP enhancement for sections that opt in via data-mingo-gsap
   - Theme-editor safe: re-binds on shopify:section:load
   ============================================================= */

(function () {
  const REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const REVEAL_SELECTOR = '[data-mingo-reveal]';

  function revealObserve(root) {
    if (REDUCED) {
      root.querySelectorAll(REVEAL_SELECTOR).forEach(el => el.classList.add('is-revealed'));
      return;
    }
    const els = root.querySelectorAll(REVEAL_SELECTOR);
    if (!els.length) return;
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach((el, i) => {
      if (!el.style.getPropertyValue('--mingo-reveal-delay')) {
        const groupIndex = parseInt(el.dataset.mingoRevealIndex || i, 10);
        el.style.setProperty('--mingo-reveal-delay', (Math.min(groupIndex, 8) * 0.08) + 's');
      }
      io.observe(el);
    });
  }

  function initSection(root) {
    if (!root || root.dataset.mingoInit === 'true') return;
    root.dataset.mingoInit = 'true';
    revealObserve(root);

    // Marquee logo strip - duplicate children for seamless loop
    root.querySelectorAll('[data-mingo-marquee]').forEach(track => {
      if (track.dataset.duplicated === 'true') return;
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      track.parentElement.appendChild(clone);
      track.dataset.duplicated = 'true';
    });

    // Count-up numbers
    if (!REDUCED) {
      root.querySelectorAll('[data-mingo-count]').forEach(el => {
        const target = parseFloat(el.dataset.mingoCount);
        const dur = parseInt(el.dataset.mingoCountDur || '1400', 10);
        const suffix = el.dataset.mingoCountSuffix || '';
        const io = new IntersectionObserver((entries, obs) => {
          if (entries[0].isIntersecting) {
            obs.disconnect();
            const start = performance.now();
            const tick = (now) => {
              const t = Math.min(1, (now - start) / dur);
              const eased = 1 - Math.pow(1 - t, 3);
              el.textContent = Math.round(target * eased).toLocaleString() + suffix;
              if (t < 1) requestAnimationFrame(tick);
            };
            requestAnimationFrame(tick);
          }
        }, { threshold: 0.4 });
        io.observe(el);
      });
    }
  }

  function destroySection(root) {
    if (!root) return;
    root.dataset.mingoInit = 'false';
  }

  function initAll() {
    document.querySelectorAll('[data-mingo-section]').forEach(initSection);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Theme editor lifecycle
  document.addEventListener('shopify:section:load', (e) => {
    const root = e.target.querySelector('[data-mingo-section]');
    if (root) initSection(root);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const root = e.target.querySelector('[data-mingo-section]');
    if (root) destroySection(root);
  });
})();
